<div data-testid="activation-funnel" class="activation-funnel">
  <div class="activation-funnel__header">
    <div class="activation-funnel__titles">
      <h4 class="activation-funnel__title">Activation funnel</h4>
      <p data-testid="activation-funnel-description" class="activation-funnel__description">{{ description }}</p>
    </div>
  </div>
  <ng-container *ngIf="funnel && funnel.signedUp > 0; else empty">
    <div #stageChart data-testid="activation-funnel-chart" class="activation-funnel__chart"
         role="img" aria-label="Activation funnel: signed up, first project, first scenario, has entities"></div>
    <p *ngIf="medianText" data-testid="activation-funnel-median" class="activation-funnel__median">{{ medianText }}</p>
    <button *ngIf="showNotBuilt" type="button" data-testid="activation-funnel-not-built" class="activation-funnel__link"
            (click)="openNotBuilt()">Who has not built a project yet</button>
  </ng-container>
  <ng-template #empty>
    <app-admin-dashboard-empty *ngIf="failed" data-testid="activation-funnel-failed" icon="fa-regular fa-circle-exclamation" [title]="failedTitle"
                               body="Try again, or pick another period." [compact]="true"></app-admin-dashboard-empty>
    <app-admin-dashboard-empty *ngIf="loaded && !failed" data-testid="activation-funnel-empty" icon="fa-regular fa-filter"
                               title="No companies joined in this period"></app-admin-dashboard-empty>
  </ng-template>
</div>
